<template>
	<section>
		<b-loading :active.sync="isLoading"></b-loading>
		<div style="display:flex; height:40px;">
			<b-button style="margin-right:3px; width:100px;" @click="openCodeModal()">
				CREATE
			</b-button>
			<template v-if="archiveCheckedList.length && params.active">
				<b-button type="is-info" style="margin-right:3px;" :disabled="!selectedAttribute" @click="assignToggle('unassign')">
					UNASSIGN
				</b-button>
				<b-button type="is-info" style="margin-right:3px;" :disabled="!selectedAttribute" @click="assignToggle('assign')">
					ASSIGN
				</b-button>
				<b-field style="margin-right: 3px;">
		            <b-select placeholder="Select Attribute" v-model="selectedAttribute">
		                <option :value="attribute" v-for="(attribute, key) in attributes">{{ attribute.name }}</option>
		            </b-select>
		        </b-field>
				<b-button type="is-info" style="margin-right:3px;" :disabled="!selectedAttribute" @click="assignToggle('assign', true)">
					ASSIGN
				</b-button>
				<b-button type="is-info" style="margin-right:20px;" :disabled="!selectedAttribute" @click="assignToggle('unassign', true)">
					UNASSIGN
				</b-button>
				<b-button
					@click="bulkArchiveRestore('archive')"
					type="is-warning">
					ARCHIVE
				</b-button>
			</template>
		</div>
		<b-button
			@click="bulkArchiveRestore('restore')"
			type="is-dark"
			v-if="restoreCheckedList.length && !params.active"
			>
			RESTORE
		</b-button>

		<b-button
			style="float: right; margin-right: 30px;margin-bottom: 20px; width:100px;"
			:loading="importLoading"
			type="is-success"
			@click="importData">
			IMPORT
		</b-button>
		<b-button
			style="float: right; margin-right: 30px;margin-bottom: 20px; width:100px;"
			:type="params.active ? 'is-success' : 'is-info'"
			@click="params.active = 0">
			ARCHIVED
		</b-button>
		<b-button
			style="float: right; margin-right: 10px;margin-bottom: 20px; width:100px;"
			:type="params.active ? 'is-info' : 'is-success'"
			@click="params.active = 1">
			ACTIVE
		</b-button>
		<div style="float: left; margin-right: 10px;margin-bottom: 20px;">
			<b-field style="max-width:400px;">
	            <b-input placeholder="SEARCH" v-model="search"></b-input>
	        </b-field>
		</div>

		<b-modal :active.sync="createCodeModal" has-modal-card trap-focus aria-role="dialog" aria-modal>
			<form @submit.prevent="submitCode">
                <div class="modal-card" style="min-width: 500px">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{ selectedCode ? 'Update' : 'Create' }}</p>
                    </header>
                    <section class="modal-card-body">
                        <b-field label="Type" v-if="canManageCodes">
                            <b-input v-model="form.type" type="text" required></b-input>
                        </b-field>
                    	<b-field label="Type" v-else>
				            <b-select v-model="form.type" expanded required>
				                <option v-for="(type, key) in types" :value="type">{{ type }}</option>
				            </b-select>
				        </b-field>
                        <b-field label="Group">
                            <b-input v-model="form.group" type="text"></b-input>
                        </b-field>
                        <b-field label="Name">
                            <b-input v-model="form.name" type="text" required></b-input>
                        </b-field>
                        <b-field label="Code">
                            <b-input v-model="form.code" type="text" required></b-input>
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="createCodeModal = false">Close</button>
                        <button class="button is-primary">Save</button>
                    </footer>
                </div>
            </form>
		</b-modal>

		<div class="table-wrapper b-table">
			<table class="table">
				<tr>
					<th class="is-narrow">
						<b-checkbox v-model="archiveCheckedListAll" v-if="params.active"></b-checkbox>
						<b-checkbox v-model="restoreCheckedListAll" v-else></b-checkbox>
					</th>
					<th>CODE</th>
					<th>NAME</th>
					<!-- <th>GROUP</th> -->
					<th>TYPE</th>
					<th>CHILD ATTRIBUTES</th>
					<th>PARENT ATTRIBUTES</th>
					<th></th>
				</tr>
				<tr v-for="(code, key) in filteredCodes">
					<td>
						<b-checkbox v-model="archiveCheckedList" :native-value="code.id" v-if="code.status"></b-checkbox>
	              		<b-checkbox v-model="restoreCheckedList" :native-value="code.id" v-else></b-checkbox>
					</td>
					<td>{{ code.code }}</td>
					<td>{{ code.name }}</td>
					<!-- <td>{{ code.group }}</td> -->
					<td>{{ code.type }}</td>
					<td>
						<label class="tag is-info" v-for="(attr, key) in code.attributes.filter(element => element.archived_at == null).map(element => element.name)">
							{{ attr }}
						</label>
					</td>
					<td>
						<label class="tag is-info" v-for="(attr, key) in code.parentAttributes.filter(element => element.archived_at == null).map(element => element.name)">
							{{ attr }}
						</label>
					</td>
					<td>
						<b-button size="is-small" @click="openCodeModal(code)" style=" margin-left:5px;">EDIT</b-button>
						<b-button style="" size="is-small" :type="code.status ? 'is-warning' : 'is-dark'" v-if="isRowChecked(code.id, code.status)" @click="archiveRestore(code.id, code.status)">
							{{ code.status ? 'ARCHIVE' : 'RESTORE' }}
						</b-button>
					</td>
				</tr>
			</table>
        </div>
        <div class="flafile-sample-csv" id="flafile-sample-csv">
        	<i class="fa fa-close close-flafile-sample-csv" @click="closeFile"></i>
        	<a :href="downloadLink" @click="closeFile" download>
        		<b-button type="is-info"><i class="fa fa-download"></i> Download Template CSV file.</b-button>
        	</a>
        </div>
	</section>
</template>
<script>
import { CodeService } from "@/services/code.service";
import FlatfileImporter from 'flatfile-csv-importer'
import VueJsonPretty from 'vue-json-pretty'
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import BaseTable from "@/components/partials/BaseTable";
import { AttributeService } from "@/services/attributes.service";
import config from "@/config/index";
export default {
	components: { VueJsonPretty, BaseTable },
	props: [ 'firm', 'organization', 'selectedCodes' ],
	codeService: CodeService,
	columns: [
		{
			field: "Action",
			label:"",
			meta:{
				rowSlot:"rowCheckbox",
				class: 'is-narrow'
			}
		},
		{ field: "code", label: "Code" },
		{ field: "name", label: "Name" },
		{ field: "group", label: "Group" },
		{ field: "type", label: "Type" },
		{
			field: "action",
			label:"",
			meta:{
				rowSlot:"rowAction",
				class: 'is-narrow'
			}
		}
	],
    data: () => ({
    	archiveCheckedListAll: false,
    	restoreCheckedListAll: false,
    	codes: [],
    	dataResult: null,
    	modalData: false,
    	importLoading: false,
    	isLoading: false,
        loading: false,
        perPage: 20,
        total: 0,
        currentPage: 1,
        params: {
        	firm_firm_id: 0,
        	order_by: 'id',
			sort_by: 'desc',
			per_page: 15,
			active: 1,
			includes: 'attributes,parentAttributes'
        },
        importer: null,
        types: null,
        // types: ['ACTIVITY', 'ASSET', 'FAILURE', 'orderType', 'PROBLEM', 'REPAIR', 'RESPONSE', '[SYSTEM][ORDER][CODE_CHAIN]'],
        displaySampleFile: false,
        archiveCheckedList: [],
        restoreCheckedList: [],
        selectedAttribute: null,
        attributes: [],
        search: '',
        createCodeModal: false,
        form: {
        	type: null,
        	group: null,
        	name: null,
        	code: null,
        },
        selectedCode: null,
    }),
    computed: {
        user() {
            return this.$store.state.Auth.user;
        },
       	canManageCodes() {
			return this.$store.getters["Auth/hasPermission"]("can manage codes")
		},
        downloadLink() {
        	return process.env.API_URL + '/flatfile/stomport-sample-file.csv';
        },
        attributeData() {
        	if (this.selectedAttribute) {
        		return {
        			id: this.selectedAttribute.id,
        			value: this.selectedAttribute.pivot.value
        		};
        	}
        	return null;
        },
        filteredCodes() {
        	if (this.search) {
        		return this.codes.filter(element => {
        			if (element.attributes.length) {
        				let childAttribute = element.attributes.filter(element => element.name.toLowerCase().includes(this.search.toLowerCase()) && element.archived_at == null);
        				let parentAttribute = element.parentAttributes.filter(element => element.name.toLowerCase().includes(this.search.toLowerCase()) && element.archived_at == null);
        				let code = element.code.toLowerCase().includes(this.search.toLowerCase());
        				let name = element.name.toLowerCase().includes(this.search.toLowerCase());
        				let group = element.group.toLowerCase().includes(this.search.toLowerCase());
        				let type = element.type.toLowerCase().includes(this.search.toLowerCase());
        				return childAttribute.length || parentAttribute.length ||
        				code || name || group || type ? true : false;
        			}
        			return false;
        		});
        	}
        	return this.codes;
        },
    },
    watch: {
    	'params.archived'() {
    		this.fetch();
    	},
    	'params.active'() {
    		this.fetch();
    	},
    	organization() {
    		this.params.firm_firm_id = this.firm.id;
    		this.$nextTick(() => {
    			this.fetch();
    		});
    		this.archiveCheckedList = [];
			this.restoreCheckedList = [];
			this.selectedAttribute = null;
    		this.getCodeAttribute();
    	},
    	archiveCheckedList(value) {
    		this.$emit('update:selectedCodes', value);
    	},
    	archiveCheckedListAll(value) {
    		if (value) {
    			this.archiveCheckedList = this.codes.map(element => element.id);
    		}else{
    			this.archiveCheckedList = [];
    		}
    	},
    	restoreCheckedListAll(value) {
    		if (value) {
    			this.restoreCheckedList = this.codes.map(element => element.id);
    		}else{
    			this.restoreCheckedList = [];
    		}
    	},

    	types(value) {

    		let options = [];
    		value.forEach((v, k) => {
    			options.push({
    				label: v,
    				value: v,
    			});
    		});

	    	config.codeFlatfileOptions.fields[0].options = options;
	    	FlatfileImporter.setVersion(2)
			this.importer = new FlatfileImporter(config.flatfileLicense, config.codeFlatfileOptions);
	    	this.importer.setCustomer({
			    userId: this.user.id,
			    name: this.user.fullName,
			    email: this.user.email,
			});

    	}
    },
    methods: {
    	async submitCode() {
    		if (this.selectedCode) {
    			await CodeService.update(this.selectedCode.id, this.form).then(response => {
	    			this.$buefy.toast.open({
						message: "Code updated",
						type: "is-success",
						position: "is-top-right"
			        });
			        this.createCodeModal = false;
		            this.fetch();
	    		});
    		} else {
	    		await CodeService.create(this.form).then(response => {
	    			this.$buefy.toast.open({
						message: "New code created",
						type: "is-success",
						position: "is-top-right"
			        });
			        this.createCodeModal = false;
		            this.fetch();
	    		});
    		}
    	},
    	isRowChecked(id, status) {
    		if (status) {
    			return this.archiveCheckedList.includes(id);
    		}else {
    			return this.restoreCheckedList.includes(id);
    		}
    	},
    	async archiveRestore(id, status) {
    		await CodeService.archive({id: id, status: status});
    		if (status) {
    			this.archiveCheckedList.splice(this.archiveCheckedList.findIndex(element => element == id), 1)
    		}else {
    			this.restoreCheckedList.splice(this.restoreCheckedList.findIndex(element => element == id), 1)
    		}
	        this.$buefy.toast.open({
				message: "Code successfully archived.",
				type: "is-success",
				position: "is-top-right"
	        });
            this.fetch();
    	},
	    async bulkArchiveRestore(type) {
	    	let message = '';
	    	if (type == 'archive') {
	    		await CodeService.bulkArchive({ids: this.archiveCheckedList});
	    		this.archiveCheckedList = [];
	    		message = 'Action Success';
	    	}else{
	    		await CodeService.bulkRestore({ids: this.restoreCheckedList});
	    		this.restoreCheckedList = [];
	    		message = 'Action Success';
	    	}
	    	this.archiveCheckedListAll = false;
			this.restoreCheckedListAll = false;
	        this.$buefy.toast.open({
				message: message,
				type: "is-success",
				position: "is-top-right"
	        });
	    	this.fetch();
	    },
	    onTableFetch(data) {
	      this.$emit("fetch", data);
	    },
        onPageChange(page) {
            this.currentPage = page;
            this.fetch();
        },
        closeFile() {
			document.getElementById("flafile-sample-csv").style.display = 'none';
        },
        async importData() {
			let element = document.getElementsByClassName("flatfile-component");
			let displaySampleFile = this.displaySampleFile;
			var observer = await new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.type == "attributes") {
						if (element[0].getAttribute("style") == 'display: block;') {
							document.getElementById("flafile-sample-csv").style.display = 'block';
						}else {
							document.getElementById("flafile-sample-csv").style.display = 'none';
						}
					}
				});
			});
			// this.displaySampleFile = displaySampleFile;
			observer.observe(element[0], {
				attributes: true
			});

        	// this.registerValidatorCallback();
			let data = await CodeService.firmFirmCodes({firm_firm_id: this.firm.id});
        	let name = data.map(element => element.name);
        	let code = data.map(element => element.code);
        	let localRecord = [];
        	this.importer.registerRecordHook((record, index) => {
        		index = index - 1;
        		if(typeof localRecord[index] === 'undefined') {
        			localRecord.push(record);
				}else{
					localRecord[index].code = record.code;
				}
        		let error = {};
        		if (! this.types.includes(record.type)) {
					error.type = {
						info: [
							{
								message: "Invalid type value.",
								level: "error"
							}
						]
					};
        		}
        		
        		if (code.includes(record.code)) {
        			error.code = {
						info: [
							{
								message: "Duplicate: This code has been imported previously.",
								level: "error"
							}
						]
					};
        		}else{
					let codeCode = localRecord.map(element => element.code);
					let count = codeCode.filter(element => element.toLowerCase() == record.code.toLowerCase()).length;
					if (count > 1) {
						error.code = {
							info: [
								{
									message: "Duplicate: Import file contains multiple records of this code.",
									level: "error"
								}
							]
						};
					}
        		}
				return error;
        	});
        	await this.importer.requestDataFromUser().then(response => {
				// this.importer.displayLoader();
				this.uploadData(response.data);
        	});
        },
        async uploadData(data) {
        	this.modalData = true;
        	await CodeService.uploadData(this.firm.id, data).then(response => {
        		this.dataResult = response;
				this.importer.close();
				// this.importer.off();
		        this.$buefy.toast.open({
					message: "Code successfully imported.",
					type: "is-success",
					position: "is-top-right"
		        });
            	this.fetch();
        	}).catch(error => {
        		this.modalData = false;
				this.importer.displayError(error.message)
        	});
        },
	    async fetch(file = null) {
	    	await CodeService.all(this.params).then(response => {
        		this.codes = JsonDenormalizer.denormalize(response);
	    	});
	    	// await this.$refs.filesTable.fetchData();
	    },
	    async getCodeAttribute() {
	    	await AttributeService.getCodeAttribute({firm: this.organization.id}).then(response => {
	    		this.attributes = response;
	    	});
	    },
	    async assignToggle(type, code = false) {
	    	if (! code) {
		    	await AttributeService.assignToggle({attribute_data: this.attributeData, type: type, ids: this.archiveCheckedList}).then(response => {
		    		this.$buefy.toast.open({
						message: "Success!",
						type: "is-success",
						position: "is-top-right"
			        });
	    			this.fetch();
		    	});
	    	}else {
		    	await CodeService.assignToggle({attribute_data: this.attributeData, type: type, ids: this.archiveCheckedList}).then(response => {
		    		this.$buefy.toast.open({
						message: "Success!",
						type: "is-success",
						position: "is-top-right"
			        });
	    			this.fetch();
		    	});

	    	}
	    },
	    openCodeModal(row = null) {
	    	this.selectedCode = row;
	    	this.createCodeModal = true;
	    	if (row) {
				this.form.name  = row.name;
				this.form.code  = row.code;
				this.form.type  = row.type;
				this.form.group = row.group;
	    	} else {
	    		this.resetForm();
	    	}
	    },
	    resetForm() {
	    	this.form.name  = null;
			this.form.code  = null;
			this.form.type  = null;
			this.form.group = null;
	    },
	    async getTypes() {
	    	await CodeService.listTypes().then(response => {
	    		this.types = response.data.map(element => element.type);
	    	});
	    }
    },
    mounted() {
    	this.params.firm_firm_id = this.firm.id;
    	this.form.firm_firm_id = this.firm.id;
    	this.fetch();
    	this.getCodeAttribute();
    	this.getTypes();

  //   	console.log(config.codeFlatfileOptions.fields[0]);


  //   	// let options = [];



  //   	FlatfileImporter.setVersion(2)
		// this.importer = new FlatfileImporter(config.flatfileLicense, config.codeFlatfileOptions);
  //   	this.importer.setCustomer({
		//     userId: this.user.id,
		//     name: this.user.fullName,
		//     email: this.user.email,
		// });

    }
};
</script>

<style scoped>
	table td {
		height: 40px;
	}
	.flafile-sample-csv{
		background-color: white;
		position: absolute;
		z-index: 100001;
		top: 0px;
		border: 1px solid #d2d2d2;
		border-radius: 7px;
		box-shadow: 1px 1px 5px darkgrey;
		margin-left: 19%;
		margin-top: 35px;
		padding: 33px 18px;
		display: none;
	}
	.close-flafile-sample-csv {
		position: absolute;
		right: -5px;
		top: -6px;
		font-size: 15px;
		color: red;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/codes/codes.vue